import {MODIFY_YIELD_SUCCESS} from 'modules/rotations/actions/RotationsActions';
import {Reducer} from 'redux';
import {
  CLEAN_FIELDS_BULK_ERRORS,
  CLEAR_FIELDS_DATA,
  FieldsActionTypes,
  LOAD_FARMERS_LIST,
  LOAD_FIELDS_SUMMARY,
  LOAD_FIELDS_SUMMARY_SUCCESS,
  ON_SELECT_CAMPAIGN,
  ON_SELECT_FIELD,
  ON_SELECT_FILTERS_SUCCESS,
  ON_SELECT_SERVICE,
  REALOAD_FIELDS_BACKGROUND_SUCCESS,
  SET_MAP_DISPLAY_NDVI,
  SET_MAP_POSITION,
  SET_SELECT_PRODUCER,
  SET_ZOOM_TO_SELECTED,
  UPDATE_FIELDS_BULK_SUCCESS,
} from '../actions/FieldsActions';
import FieldsState from '../models/FieldsState';

const initialState: FieldsState = {
  count: null,
  fieldsList: {},
  campaigns: null,
  crops: [],
  farmers: [],
  farmersList: [],
  selectedFieldId: null,
  zoomToSelected: false,
  selectedCampaign: null,
  selectedService: null,
  mapPosition: {
    latitude: 0,
    longitude: 0,
    zoom: 3,
  },
  bbox: [],
  filteredFields: [],
  filteredFieldsBbox: [],
  selectedFilters: {},
  mapDisplayNdvi: false,
  selectedProducer: null,
  fieldUpdateErrors: null,
};

const fieldsReducers: Reducer<FieldsState, FieldsActionTypes> = (
  state: FieldsState = initialState,
  action: FieldsActionTypes,
) => {
  switch (action.type) {
    case UPDATE_FIELDS_BULK_SUCCESS:
      const updatedFieldsList = {...state.fieldsList};
      action.payload.fields.forEach((field) => {
        updatedFieldsList[field.field_id] = field;
      });
      return {
        ...state,
        fieldsList: updatedFieldsList,
        fieldUpdateErrors: action.payload.errors,
      };

    case CLEAN_FIELDS_BULK_ERRORS:
      return {
        ...state,
        fieldUpdateErrors: null,
      };
    case REALOAD_FIELDS_BACKGROUND_SUCCESS:
      return {
        ...state,
        fieldsList: {
          ...state.fieldsList,
          ...action.payload,
        },
      };
    case ON_SELECT_SERVICE:
      return {
        ...state,
        selectedService: action.payload,
      };
    case LOAD_FIELDS_SUMMARY:
      return {
        ...state,
      };
    case LOAD_FIELDS_SUMMARY_SUCCESS:
      return {
        selectedFilters: state.selectedFilters,
        ...action.payload,
      };
    case ON_SELECT_FIELD:
      return {
        ...state,
        selectedFieldId: action.payload.selectedFieldId,
        zoomToSelected: action.payload.zoomToSelected,
      };
    case SET_ZOOM_TO_SELECTED:
      return {
        ...state,
        zoomToSelected: action.payload.zoomToSelected,
      };
    case SET_MAP_POSITION:
      return {
        ...state,
        mapPosition: action.payload,
      };
    case CLEAR_FIELDS_DATA:
      return {
        ...initialState,
      };
    case ON_SELECT_FILTERS_SUCCESS:
      return {
        ...state,
        selectedFilters: action.payload.selectedFilters,
        filteredFields: action.payload.filteredFields,
        filteredFieldsBbox: action.payload.filteredFieldsBbox,
        zoomToSelected: action.payload.zoomToSelected,
      };
    case SET_MAP_DISPLAY_NDVI:
      return {
        ...state,
        mapDisplayNdvi: action.payload,
      };
    case ON_SELECT_CAMPAIGN:
      return {
        ...state,
        selectedCampaign: action.payload,
      };
    case LOAD_FARMERS_LIST:
      return {
        ...state,
        farmersList: action.payload,
      };
    case SET_SELECT_PRODUCER:
      return {
        ...state,
        selectedProducer: action.payload,
      };
    case MODIFY_YIELD_SUCCESS:
    /*if (!state.data) {
        return state;
      }

      const updatedData = Object.fromEntries(
        Object.entries(state.data).map(([campaignId, fields]) => {
          const updatedFields = Object.fromEntries(
            Object.entries(fields).map(([fieldId, field]) => {
              if (field.field_id === action.payload.field_id) {
                const newIrrigation = field.irrigation.map((irrigation) => {
                  if (
                    irrigation.rotation_id ===
                    action.payload.rotation.rotation_id
                  ) {
                    return {
                      ...irrigation,
                      ...action.payload.rotation,
                    };
                  }
                  return irrigation;
                });

                return [
                  fieldId,
                  {
                    ...field,
                    irrigation: newIrrigation,
                  },
                ];
              }

              return [fieldId, field];
            }),
          );

          return [campaignId, updatedFields];
        }),
      );

      return {
        ...state,
        data: updatedData,
      };*/
    default:
      return state;
  }
};
export default fieldsReducers;
